import type { BranchKey, WorkspaceKey } from '@festina-life/api'
import type { Optional } from '@festina-life/core'

export type MergeResult = {
  hostBranchKey: BranchKey
  conflictsWorkspaceKey: Optional<WorkspaceKey>
}

export type UpgradeResult = {
  hostBranchKey: BranchKey
}

export const FinalUpgradeStatuses = [
  'success',
  'compareWarning',
  'error',
] as const
export type FinalUpgradeStatus = (typeof FinalUpgradeStatuses)[number]
export type UpgradeStatus =
  | 'comparing'
  | 'creatingBranch'
  | 'addingChangesets'
  | 'squashingBranch'
  | FinalUpgradeStatus

export const FinalMergeCompareStatuses = ['success', 'error'] as const
export type FinalMergeCompareStatus = (typeof FinalMergeCompareStatuses)[number]
export type MergeCompareStatus = 'comparing' | FinalMergeCompareStatus

export const FinalMergeStatuses = [
  'successNoConflicts',
  'successWithConflicts',
  'error',
] as const
export type FinalMergeStatus = (typeof FinalMergeStatuses)[number]
export type MergeStatus =
  | 'creatingBranch'
  | 'addingChangesets'
  | 'squashingBranch'
  | 'creatingWorkspace'
  | FinalMergeStatus

export const isFinalMergeCompareStatus = (
  status: MergeCompareStatus,
): status is FinalMergeCompareStatus =>
  (FinalMergeCompareStatuses as readonly MergeCompareStatus[]).includes(status)

export const isFinalMergeStatus = (
  status: MergeStatus,
): status is FinalMergeStatus =>
  (FinalMergeStatuses as readonly MergeStatus[]).includes(status)

export const isFinalUpgradeStatus = (
  status: UpgradeStatus,
): status is FinalUpgradeStatus =>
  (FinalUpgradeStatuses as readonly UpgradeStatus[]).includes(status)
